module.exports = __webpack_public_path__ + "static/agriculture-7efd1b211cbef802cfefd8f1c31b654a.jpg";